import { recordPath, recordRoute } from '@/shared/registry'

/** Where the Notification Plan pages live. */
export const rulesPath = '/notifications/plans'
export const createRulePath = `${rulesPath}/new`
export const ruleRoute = recordRoute('notifications', 'plans')
export const editRuleRoute = `${ruleRoute}/edit`

/** A Notification Plan's details page. */
export function rulePath(id: string): string {
  return recordPath('notifications', 'plans', id)
}

export function editRulePath(id: string): string {
  return `${rulePath(id)}/edit`
}

/** Find Sent Notifications from a plan's details: the messages its rule wrote. */
export const ruleSentMessagesRoute = `${ruleRoute}/sent-messages`

export function ruleSentMessagesPath(id: string): string {
  // Filtered to the plan, as the API's `ruleId` filter takes it.
  const query = new URLSearchParams({ filter: `ruleId:in:${id}` })
  return `${rulePath(id)}/sent-messages?${query.toString()}`
}

/** The base of a plan's details slots (`detailsSlots`). */
export const ruleDetailsSlot = 'notifications.rule-details'

/** The API's Notification Plan endpoints. */
export const rulesApi = '/notifications/v1/rules'

export function ruleApi(id: string): string {
  return `${rulesApi}/${encodeURIComponent(id)}`
}

/** The placeholders a trigger's message text may use (NTF-07). */
export function placeholdersApi(trigger: string): string {
  return `/notifications/v1/placeholders?${new URLSearchParams({ trigger }).toString()}`
}

/** What each plan action needs. */
export const readRulesPermission = 'notifications.notification-rule.read'
export const writeRulesPermission = 'notifications.notification-rule.write'
export const deleteRulesPermission = 'notifications.notification-rule.delete'

/** Making a plan apply to every organization, or no longer to every one. */
export const everyOrganizationRulesPermission = 'notifications.notification-rule.for-every-organization.write'
